import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse
} from '@angular/common/http';
//import { BehaviorSubject, catchError, filter, map, Observable, switchMap, take, throwError } from 'rxjs';
import { map, catchError, filter, take, switchMap } from 'rxjs/operators';
//import { StorageService } from '../services/storage/storage.service';
import { Router } from '@angular/router';
import { AuthConstants } from '../config/auth-constants';
//import { AuthService } from '../services/auth/auth.service';
//import { StorageService } from '../services/storage.service';
import { BehaviorSubject, Observable, throwError } from 'rxjs';
//import { EncryptionService } from './encryption.service';
import { AuthService } from '../services/auth.service';
import { StorageService } from '../services/storage.service';
import { EncriptadorService } from '../services/encriptador.service';
//import { StorageService } from './storage.service';
import { Plugins } from '@capacitor/core';
import { environment } from 'src/environments/environment';

const { Storage } = Plugins;

const TOKEN_HEADER_KEY = 'Authorization';  

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  private isRefreshing = false;
  private refreshTokenSubject: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  private DataStorage:any;
  private _TOKEN_encript:any;
  constructor(
    private authService:AuthService,
    private storageService:StorageService,
    private router:Router,
    private encryption:EncriptadorService
  ) {
    /* this.refreshTokenSubject.subscribe(res=>{
      console.log("refreshTokenSubject:",res);
    }); */
  }

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    
    let token:any;
    let authReq = req;
    //token = localStorage.getItem(AuthConstants.AUTH);
    let TOKEN:any;
    let refresh_token:any;
    if(!this._TOKEN_encript){
      token = Storage.get({key:AuthConstants.AUTH});
      token = token.__zone_symbol__value.value;
      this._TOKEN_encript = token;
    }else{
      token = this._TOKEN_encript;
    }
    
    
    //console.log("intercept1: ",AuthConstants.apiIpAddress);
    //console.log("intercept: ",authReq.url.includes("evento/apievento") + "-" + authReq.url);
    if(authReq.url != AuthConstants.apiIpAddress && authReq.url != environment.epaycoUrl + "bancos")
    if (token && !authReq.url.includes('login') && !authReq.url.includes('refresh-token' ) && !authReq.url.includes('logout' )) {
      //if (token && authReq.url.includes('evento/apievento')   ) {
      //let dataStorage = JSON.parse(unescape(atob(token)));
      let dataStorage = null;
      if(!this.DataStorage){
        dataStorage = JSON.parse(this.encryption.decrypt(unescape(atob(token))));
        this.DataStorage = dataStorage;
      }else{
        dataStorage = this.DataStorage;
      }
      
      
      refresh_token = dataStorage.refresh_token;
      TOKEN = dataStorage.token;
      //console.log("intercept: ",dataStorage);
      authReq = this.addTokenHeader(req, TOKEN);
    }else if(authReq.url.includes('refresh-token' )){
      
      //authReq = authReq.clone({ headers: authReq.headers.set("Content-Type", "application/json") });
    }
    return next.handle(authReq).pipe(catchError( error => {
      
      if (error instanceof HttpErrorResponse && !authReq.url.includes('auth/signin') && error.status === 401) {
        //console.log("401 error.status: ",error.status);
        return this.handle401Error(authReq, next);
        //return throwError(error);
      }else{
        //console.log("No 401 error.status: ",error.status);
        return this.handle401Error(authReq, next);
      }
      //return throwError(error);
    }));
  }


  private handle401Error(request: HttpRequest<any>, next: HttpHandler) {
    if (!this.isRefreshing) {
      this.isRefreshing = true;
      this.refreshTokenSubject.next(null);

      //const token:any = localStorage.getItem(AuthConstants.AUTH);
      
      const token:any = Storage.get({key:AuthConstants.AUTH});
      let dataStorage:any = "";
      
      let TOKEN = "";
      if (token){
        dataStorage = JSON.parse(this.encryption.decrypt(unescape(atob(token.__zone_symbol__value.value))));
        
        TOKEN = dataStorage.refresh_token;
      }else{
        console.log("No token");
        //return next.handle(request);
      }
      
      this.authService.refreshToken().subscribe((response:any)=>{
        this.isRefreshing = false;
        
        //console.log("refreshToken2:",response);
        if(response.statusCode != undefined && response.statusCode == "401"){
          //console.log("refreshToken statusCode: logout",response.statusCode);
          this.authService.logout();
          //this.router.navigate(['/login']);
          return throwError(request);
          return next.handle(request);
        }
        /*console.log("refreshToken3:",response.token);
        console.log("refreshToken4:",dataStorage);*/
        dataStorage.token = response.token;
        this.DataStorage = dataStorage;
        this.storageService.storage(AuthConstants.AUTH, dataStorage).then((result:any)=>{
          let token:any = Storage.get({key:AuthConstants.AUTH});
          token = token.__zone_symbol__value.value;
          this._TOKEN_encript = token;
        });//dataStorage.token
        this.refreshTokenSubject.next(dataStorage.token);
        //console.log("response:",response);
        return next.handle(this.addTokenHeader(request, dataStorage.token));
      }),catchError((err) => {
        console.log("ERROR: ",err);
        this.isRefreshing = false;
        this.authService.logout();
        //????
        this.router.navigate(['/login']);
        return throwError(err);
      });
    }

    return this.refreshTokenSubject.pipe(
      filter(token => token !== null),
      take(1),
      switchMap((token) => next.handle(this.addTokenHeader(request, token)))
    );
  }
  
  private addTokenHeader(request: HttpRequest<any>, token: string) {
    return request.clone({ headers: request.headers.set(TOKEN_HEADER_KEY, 'Bearer ' + token) });
  }
  
}